<template>
	<span>{{ textService(params.value) }}</span>
</template>

<script>
export default {
	name: "CellRendererService",
	computed: {
		textService() {
			return (value) => {
				if (value === "optimization") return this.$t("Optimization.Optimization");
				else if (value === "routing") return this.$t("RoutingService");
				else if (value === "matrix") return this.$t("Matrix");
				else if (value === "mapmatching") return this.$t("MapMatching");
				else if (value === "isochrones") return this.$t("Isochrones");
				else if (value === "clustering") return this.$t("Clustering.Title");
			};
		},
	},
};
</script>
